import { useMemo } from "react";
import { IThemeColor } from "../theme/colors";
import { IScreenSizes } from "../theme/sizes";

import { ITheme } from "../theme";
import { useColors } from "./useColors";
import { useScreenSizes } from "./useSizes";
import { useTheme } from "./useTheme";

interface ScaledSize {
  width: number;
  height: number;
  scale: number;
  fontScale: number;
}

type Generator<K = unknown, T = unknown> = ({
  colors,
  theme,
  stylesProps,
  window,
}: {
  colors?: IThemeColor;
  theme?: ITheme;
  stylesProps?: K;
  window?: ScaledSize;
  sizes?: IScreenSizes;
}) => T;

const useStyles = <K = unknown, T = unknown>(
  fn: Generator<K, T>,
  stylesProps?: K
): T => {
  const theme = useTheme();
  const colors = useColors();
  const sizes = useScreenSizes();

  return useMemo(
    () => fn({ colors, theme, stylesProps, sizes }),
    [fn, colors, theme, stylesProps, sizes]
  );
};

export type { ScaledSize };
export { useStyles };
